//import Inverter from "./Inverter.js";
//import Inversor from "./Inversor.js"
//import { get } from "core-js/core/dict";
import Quote from "../classes/Quote";
import SolarPlant from "../classes/SolarPlant";
import deals from "./deals"
import enterprises from "./enterprises"
import users from "./users"
import devices from "./devices"
import projects from "./projects"
import fields from "./fields"
import cities from "./cities"
import contacts from "./contacts"
import currencies from './currencies'

var debug = false;
var hebelApi = {
//   //db = this.$firebase.firestore();
//   firebase:{},
//   name:"teste",

    deals:deals, // deals functions . get, post, patch,del
    enterprises:enterprises,
    users:users,
    devices:devices,
    projects:projects,
    fields:fields,
    cities:cities, 
    contacts:contacts,    
    currencies:currencies



  


}



export default hebelApi;